module.exports = __webpack_public_path__ + "static/media/Maf_Curso_06ActualizacionPeritos.a82a501b.jpg";